export enum Language {
  IT = 'it',
  DE = 'de'
}